
export { GGUSection } from "/codebuild/output/src2410076634/src/packages/shared-components/src/campaign/GGUSection.tsx"